import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './reducers';

function extractStateFromAttributes(attributes) {
  const state = {
    type: 0,
  };

  if (attributes) {
    const stateAttributeNames = [
      'type', 'program-code',
      'mealplans', 'selected-mealplan',
      'durations', 'selected-duration',
      'roomtypes', 'selected-roomtype',
      'arrivals', 'selected-arrival',
      'rate', 'labels',
    ];

    stateAttributeNames.forEach((attributeName) => {
      const propertyName = attributeName.replace(/-([a-z])/g, (x, up) => up.toUpperCase());
      const item = attributes.getNamedItem(attributeName);

      if (item && item.value) {
        state[propertyName] = item.value.match(/^\s*[{\[]/) ? JSON.parse(item.value) : item.value;
      }
    });
  }

  return state;
}

export default function configureStore(attributes) {
  return createStore(
    rootReducer,
    extractStateFromAttributes(attributes),
    applyMiddleware(thunkMiddleware),
  );
}
